<section class="space-y-4">
  <div class="flex items-center justify-between">
    <div>
      <h2 class="text-2xl font-semibold text-slate-900">Accounts</h2>
      <p class="text-sm text-slate-500">Manage the people and releasers on the platform.</p>
    </div>
  </div>
  <app-accounts-table />
</section>
